/**
 * @file コンポーネント：アカウントメニュー ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// 関数読み込み
import {
    fnGetCultureLanguage,
    fnHandleApiErrors,
    fnHandleApiSuccess,
    fnSetCookie,
} from "~/src/functions/common";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const Accountmenu = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    /**
     * 言語切り替え
     */
    const languageCode = fnGetCultureLanguage();
    // 言語切り替え時の処理
    const fnChangeLanguage = (lang) => {
        // 表示中の言語と異なる言語が選択された場合のみ処理
        if (languageCode !== lang) {
            // カルチャー言語切り替えAPI処理
            const api = "/api/users/languages";
            const params = { languageCode: lang };
            const options = {
                body: JSON.stringify(params),
                headers: {
                    "Content-Type": "application/json",
                    RequestVerificationToken: document
                        .getElementById("requestverificationtoken")
                        .getAttribute("value"),
                },
                method: "PUT",
            };
            fetch(api, options)
                .then(fnHandleApiErrors)
                .then(fnHandleApiSuccess)
                .then((result) => {
                    if (result !== null) {
                        // 成功時、cookieに値をセットしてリロード
                        const value = "c%3Dja%7Cuic%3D" + lang;
                        fnSetCookie(".AspNetCore.Culture", value, 7, "/");
                        location.reload();
                    }
                })
                .catch((error) => {
                    console.error(error);
                    // エラー時、アラートを出す
                    alert(localized["ErrorMessage.FailChangeLanguage"]);
                });
        }
    };

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnChangeLanguage={fnChangeLanguage}
            languageCode={languageCode}
        />
    );
};
